export default __webpack_public_path__ + "static/media/sunset-waves-bottom.dbb5ffdb.svg";